import { useState, useEffect } from 'react';
import apiClient from '@/lib/axios';
import type { Estimator, ApiResponse } from '../types';

/**
 * Hook to fetch active estimators for lead assignment
 * Fetches users with role=Estimator and isActive=true
 */
export function useEstimators() {
  const [estimators, setEstimators] = useState<Estimator[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchEstimators = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const response = await apiClient.get<ApiResponse<Estimator[]>>('/users', {
          params: {
            role: 'Estimator',
            isActive: true,
          },
        });

        const sorted = [...response.data.data].sort((a, b) =>
          a.fullName.localeCompare(b.fullName, undefined, { sensitivity: 'base' })
        );
        setEstimators(sorted);
      } catch (err) {
        const error = err as { response?: { data?: { message?: string } } };
        setError(error.response?.data?.message || 'Failed to fetch estimators');
      } finally {
        setIsLoading(false);
      }
    };

    fetchEstimators();
  }, []);

  return {
    estimators,
    isLoading,
    error,
  };
}
